
<div class="inline"><span>Votos restantes:</span>
    {{myVotes}}
</div>
